import { render } from "./UOMClass.vue?vue&type=template&id=5f6d5c4f"
import script from "./UOMClass.vue?vue&type=script&lang=js"
export * from "./UOMClass.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__